// Plain-language messages for the Firebase Auth errors a customer can meet on
// the sign-in and sign-up pages, in place of Firebase's own
// "Firebase: Error (auth/invalid-credential)." text.

// Firebase answers a wrong password, an address with no account, and an
// account with no password the same way, so as not to reveal which addresses
// have accounts. The last happens more than it sounds: Firebase removes the
// password from a Gmail account whose address was never verified as soon as
// someone uses "Sign in with Google" with it, so the message points there too.
export const WRONG_CREDENTIALS =
  "That email and password don't match an account. If you've ever used " +
  "\"Sign in with Google\" with this email, use that button instead, or reset " +
  'your password with "Forgot password?".';

const MESSAGES = {
  'auth/invalid-credential': WRONG_CREDENTIALS,
  'auth/invalid-login-credentials': WRONG_CREDENTIALS,
  'auth/wrong-password': WRONG_CREDENTIALS,
  'auth/user-not-found': WRONG_CREDENTIALS,
  'auth/invalid-email': 'Enter a valid email address.',
  'auth/missing-email': 'Enter your email address.',
  'auth/missing-password': 'Enter your password.',
  'auth/weak-password': 'Choose a password of at least 6 characters.',
  'auth/password-does-not-meet-requirements': 'Choose a password of at least 6 characters.',
  'auth/email-already-in-use':
    'There is already an account with this email. Sign in instead, or use "Forgot password?" on the sign-in page.',
  'auth/user-disabled': 'This account has been switched off. Please contact us.',
  'auth/too-many-requests':
    'Too many attempts. Please wait a few minutes, or reset your password with "Forgot password?".',
  'auth/network-request-failed': "We couldn't reach the server. Check your connection and try again.",
  'auth/popup-blocked': 'Your browser blocked the Google sign-in window. Allow pop-ups for this site and try again.',
  'auth/account-exists-with-different-credential':
    'There is already an account with this email. Sign in with your email and password instead.',
};

// The Google window closing, or a second click replacing the first, is the
// customer's own doing and needs no message.
const SILENT = new Set(['auth/popup-closed-by-user', 'auth/cancelled-popup-request', 'auth/user-cancelled']);

/** Whether an error should be shown at all. */
export function isSilentAuthError(error) {
  return SILENT.has(error && error.code);
}

/** The message to show a customer for a Firebase Auth error. */
export function authErrorMessage(error) {
  const code = error && error.code;
  if (code && MESSAGES[code]) return MESSAGES[code];
  return code
    ? `Something went wrong (${code.replace(/^auth\//, '')}). Please try again.`
    : 'Something went wrong. Please try again.';
}
